const ROOT = 'UPDATE_AGENCY_CONTRACT_';

const actions = {
  LOAD_DATA_REQUEST: `${ROOT}LOAD_DATA_REQUEST`,
  LOAD_DATA_SUCCESS: `${ROOT}LOAD_DATA_SUCCESS`,
  LOAD_DATA_ERROR: `${ROOT}LOAD_DATA_ERROR`,
  CHANGE_PROPERTY: `${ROOT}CHANGE_PROPERTY`,
  PROCESS_ACTION_REQUEST: `${ROOT}PROCESS_ACTION_REQUEST`,
  PROCESS_ACTION_SUCCESS: `${ROOT}PROCESS_ACTION_SUCCESS`,
  PROCESS_ACTION_ERROR: `${ROOT}PROCESS_ACTION_ERROR`,
  UPDATE_FORM_INFO: `${ROOT}UPDATE_FORM_INFO`,
  CHANGE_STEP: `${ROOT}CHANGE_STEP`,
  CHANGE_MARKUP: `${ROOT}CHANGE_MARKUP`,
  CHANGE_POSITION_PRICING: `${ROOT}CHANGE_POSITION_PRICING`,
  CHANGE_POSITION_ENABLED: `${ROOT}CHANGE_POSITION_ENABLED`,
  UPDATE_AGENCY: `${ROOT}UPDATE_AGENCY`,
  ON_CREATE_CONTRACT_ERROR: `${ROOT}ON_CREATE_CONTRACT_ERROR`,
  CLEAR_STATE: `${ROOT}CLEAR_STATE`,
  CHANGE_DISTRICT_MARKUP: `${ROOT}CHANGE_DISTRICT_MARKUP`,
  CHANGE_POSITION_MARKUP: `${ROOT}CHANGE_POSITION_MARKUP`,
  ON_VALIDATE_POSITION_ERROR: `${ROOT}ON_VALIDATE_POSITION_ERROR`,
  ON_VALIDATE_POSITION_SUCCESS: `${ROOT}ON_VALIDATE_POSITION_SUCCESS`,
  APPLY_MARKUP_TO_POSITIONS: `${ROOT}APPLY_MARKUP_TO_POSITIONS`,
} as const;

export default actions;
